import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MarkantElementsModule } from '@markant/elements-angular';
import { Subscription } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';

export type requestWidgetTypes = 'platformRequests' | 'contactRequests' | 'orderRequest' | 'priceRequests';
export interface DataWidget {
  count: number;
  label: string;
}

@Component({
  selector: 'markant-platform-requests-widget-v2',
  templateUrl: 'requests-widget-v2.component.html',
  styleUrls: ['requests-widget-v2.component.scss', 'skeleton.component.scss'],
  standalone: true,
  imports: [TranslocoPipe, MarkantElementsModule],
})
export class BaseRequestsWidgetV2Component implements OnInit, OnDestroy {
  @Input() loading = true;
  @Input() widgetType!: requestWidgetTypes;
  @Input() title?: string;
  @Input() icon?: string;
  @Input() description?: string;
  @Input() secondSectionLabel?: string;
  @Input() openRequests?: DataWidget;
  @Input() inProgressRequests?: DataWidget;
  @Input() openUpgrade?: number;
  @Input() inProgressUpgrade?: number;
  @Input() inProgressUpgradeTooltip?: string;
  @Input() openUpgradeTooltip?: string;

  routerSubscription: Subscription | undefined;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        const tooltip = document.querySelector('.markant-popover--animate');

        if (tooltip) {
          tooltip.remove();
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
